import TableActionBar from './TableActionBar';

/** @deprecated Use TableActionBar — kept for backward-compatible imports. */
export default TableActionBar;
